import { z } from 'zod';

const textObject = z.object({
  $type: z.literal('v:Text'),
  Value: z.string(),
});

const booleanObject = z.object({
  $type: z.literal('v:Boolean'),
  Value: z.boolean(),
});

const commonData = {
  IsValid: z.boolean(),
  IsInvalid: z.boolean(),
  DigitsCollected: z.number(),
  IsCurrent: z.boolean(),
  IsUpdating: z.boolean(),
  VariableType: z.string(),
  Timeout: z.string(),
  ActionOnHash: z.string(),
  ActionOnStar: z.string(),
  CollectionContext: z.object({
    DtmfHashOptions: z.number(),
    DtmfStarOptions: z.number(),
  }),
};

export const pciPalPostData = z.object({
  PaymentDetails: z.object({
    AttemptCount: z.number(),
    SuccessCount: z.number(),
    FailureCount: z.number(),
    ErrorCount: z.number(),
  }),
  VariableData: z.object({
    PAN: z.object({
      Bin: z.string(),
      Last4: z.string(),
      Scheme: z.string(),
      Mask: z.string(),
      ...commonData,
    }),
    Expiry: z.object({
      ExposeToFlow: z.boolean(),
      Month: z.string(),
      Year: z.string(),
      FullYear: z.string(),
      ...commonData,
    }),
    CV2: z.object(commonData),
    bill_to_forename: textObject,
    bill_to_surname: textObject,
    bill_to_address_line1: textObject,
    bill_to_addresss_city: textObject,
    bill_to_address_state: textObject,
    bill_to_address_postal_code: textObject,
    bill_to_address_country: textObject,
    bill_to_email: textObject,
    bill_to_phone: textObject,
    runSubscriptionService: booleanObject,
    Amount: z.object({
      $type: z.literal('v:FinancialValue'),
      Value: z.number(),
      CollectionContext: z.null(),
    }),
    timestamp: z.object({
      $type: z.literal('v:DateTime'),
      Value: z.string(),
      CollectionContext: z.null(),
    }),
    expiryDate: z.object({
      $type: z.literal('v:DateTime'),
      Value: z.string(),
      CollectionContext: z.null(),
    }),
    clientApplicationUser: textObject,
    currency: textObject,
    cardType: textObject,
    runAuthService: booleanObject,
    runCaptureService: booleanObject,
    merchantReferenceCode: textObject,
    requestID: textObject,
    Decision: textObject,
    reasonCode: textObject,
    missingField: textObject,
    invalidField: textObject,
    authReasonCode: textObject,
    authAmount: textObject,
    authCode: textObject,
    avsCode: textObject,
    processorResponse: textObject,
    captureReasonCode: textObject,
    requestDateTime: textObject,
    captureAmount: textObject,
    captureReconciliationID: textObject,
    subscriptionReasonCode: textObject,
    subscriptionID: textObject,
    merchantReferenceCode_out: textObject,
    result_description: textObject,
    errorMessage: textObject,
    StatusCode: textObject,
    FullResponse: textObject,
    customerId: textObject,
    cardholderName: textObject,
  }),
});
